import { selectors } from 'darwin_core';

// The clock time a running Plus Hours / Boost hands back to the schedule, in the
// zone's own 12/24-hour format — what the app shows for a hold ("Until 3:30pm",
// PlusHoursActionPanel) in place of a countdown. null when no hold is running.
// getPlusHoursEndtime is the same selector the app reads; it returns a moment in
// the device's clock (Europe/London), so the time matches the thermostat's own
// display. Guarded: neither a missing zone nor an unreadable time-format setting
// may take a screen down — the format falls back to the app's 12-hour default.
export function plusHoursEndText(state, homeId, zoneId) {
  let end;
  try {
    end = selectors.getPlusHoursEndtime(state, homeId, zoneId);
  } catch {
    return null;
  }
  if (!end) {
    return null;
  }
  let format = 'h:mma';
  try {
    format = selectors.getTimeDisplayFormat(state, homeId, zoneId) || format;
  } catch {
    // keep the default
  }
  return end.format(format);
}
